/** zh-CN catalogue `info` (W3-09; English: src/formats/info/info.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'info',
  locale: 'zh-CN',
  messages: {
    'diag.quotedNumber': 'info.yml 中的数字“{detail}”写在了引号里，Phira 会因此停止导入谱面包。已使用该数字。',
    'diag.quotedBool':
      'info.yml 中的开关“{detail}”写在了引号里（true 或 false 必须直接书写），Phira 会因此停止导入谱面包。已使用该值。',
    'diag.yamlError':
      '无法按 Phira 的方式读取 info.yml（{detail}），Phira 会因此停止导入谱面包。已在需要处使用默认值。',
    'diag.txtHeader': 'info.txt 的第一行必须恰好是“#”，Phira 会因此停止导入谱面包。文件仍已读取。',
    'diag.badTxtLine': '这一行 info.txt 的字段名和值之间缺少“: ”：“{detail}”。Phira 会因此停止导入谱面包。已跳过该行。',
    'diag.txtParseFloat': '清单中的“{detail}”不是普通数字，Phira 会因此停止导入谱面包。已使用默认值。',
    'diag.csvEmpty': 'info.csv 的表头下没有数值行，Phira 会因此停止导入谱面包。已使用默认值。',
    'diag.encodingGuessed': '清单不是 UTF-8 文本，已按 {detail} 读取。Phira 也能识别这种情况。导出时会写为 UTF-8。',
    'diag.multipleCharts':
      '谱面包中有多个谱面文件（{detail}），但清单中指定的文件都不存在。Phira 会以不确定的顺序选择其中一个，甚至可能选中 extra.json。已使用“{chosen}”：谱面包中第一个属于谱面的文件（extra.json、phiedit.json 和 export.json 永远不是谱面）。导出时总会写明谱面文件。',
    'diag.chartMissing': '找不到谱面文件（清单中指定的是“{detail}”），Phira 会因此停止导入谱面包。',
    'diag.musicMissing': '找不到音乐文件（清单中指定的是“{detail}”）。Phira 能导入谱面，但无法播放。',
  },
};

export default catalog;
